<div class="grid-with-toolbar">
  @if (showToolbar) {
    <div class="toolbar">
      <div class="toolbar-left-section toolbar-item">
        <ng-content select="[toolbar]"></ng-content>
        <ng-content select="[toolbar-action-handler]"></ng-content>
      </div>
      <div class="toolbar-right-section toolbar-item">
        @if (!hideClearFilter) {
          <ra-ui-text-button
            [disabled]="disableClearFilter || !isSortFilterAppliedImpl"
            label="Clear filters"
            icon="ra-icon-ide-sm-remove"
            [config]="{ displayIconAfterText: false }"
            (click)="onClearAllSortFilters()"
          >
          </ra-ui-text-button>
        }
        <ng-content class="toolbar-item" select="[export-to-file]"></ng-content>
      </div>
    </div>
  }
  <ag-grid-angular
    class="ag-theme-alpine ag-grid-style"
    [theme]="'legacy'"
    [getRowId]="getRowId"
    [gridOptions]="gridOptions"
    [columnDefs]="columnDefs"
    [modules]="modules"
    [masterDetail]="masterDetail"
    [detailRowAutoHeight]="detailRowAutoHeight"
    [detailCellRenderer]="detailCellRenderer"
    [detailCellRendererParams]="detailCellRendererParams"
    (gridReady)="onGridReady($event)"
    (firstDataRendered)="onFirstDataRendered($event)"
    (rowDataUpdated)="onRowDataUpdated($event)"
    (modelUpdated)="onModelUpdated()"
    (rowSelected)="onRowSelected($event)"
    (rowClicked)="onRowClicked($event)"
    (sortChanged)="onSortChanged($event)"
    (filterChanged)="onFilterChanged($event)"
    (paginationChanged)="onPaginationChanged($event)"
  >
  </ag-grid-angular>
</div>
